/**
 * 日付を「月/日」形式（西暦なし）で返す。例: 2026-08-14 → "8/14"
 * 旗揚げ（キャンバス）表示のスペース節約用。DBには年込みで保持されている。
 */
export const formatMonthDay = (date: Date): string => `${date.getMonth() + 1}/${date.getDate()}`;
